// Colors
export const backgroundColor = 238;
export const blackColor = "#000000";
export const yellowColor = "#f6bc00";
export const colorAzul = "#0069b6";
export const colorRojo = "#e12f28";

export const COLORS = {
    BG: 238,
    BLACK: "#000000",
    YELLOW: "#f6bc00",
    BLUE: "#0069b6",
    RED: "#e12f28"
}